import React, { useEffect, useState } from "react";
import SideMenu from "../../components/SideMenu";
import Footer from "../../components/Footer";
import RampsService from "../../services/RampsService";
import CustodyWalletCard from "../../components/Ramps/CustodyWalletCard";
import FiatAccountsCard from "../../components/Ramps/FiatAccountsCard";
import RampOnboardingGate, { isRampApproved } from "../../components/Ramps/OnboardingGate";
import RampOnboardingForm from "../../components/Ramps/OnboardingForm";

export default function Ramps() {

  const [balance, setBalance] = useState(null);
  /*
    Cadastro no provedor de rampa. `null` enquanto carrega — e a tela NÃO decide
    nada com null: mostrar o formulário antes de saber se já existe cadastro
    convidaria o cliente a preencher de novo o que ele já preencheu.
  */
  const [rampProfile, setRampProfile] = useState(null);
  const [showOnboarding, setShowOnboarding] = useState(false);
  /*
    A carteira por REDE, não "o endereço do USDT": aquela pergunta não tem resposta única
    numa carteira que nasce com endereço em seis ou sete redes.
  */
  const [wallet, setWallet] = useState(null);
  const [walletLoading, setWalletLoading] = useState(true);
  /* Contas que recebem o saque em EUR e USD, e os trilhos aprovados para a empresa. */
  const [ramp, setRamp] = useState(null);
  const [rampLoading, setRampLoading] = useState(true);

  const [show2FAModal, setShow2FAModal] = useState(false);
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [loading2FA, setLoading2FA] = useState(false);

  const [withdrawInfo, setWithdrawInfo] = useState({
    amount: "",
    address: "",
    network: "",
    email: "",
  });
  const [withdrawLoading, setWithdrawLoading] = useState(false);
  const [withdrawSuccess, setWithdrawSuccess] = useState(false);





  const getUserEmail = () =>
    sessionStorage.getItem("emailUser") ||
    localStorage.getItem("emailUser") ||
    localStorage.getItem("user_email") ||
    localStorage.getItem("email") ||
    "";




  // Função para saque USDT
  const handleWithdrawUsdt = async () => {
    const email = getUserEmail();
    if (!email) {
      alert("Usuário não identificado");
      return;
    }

    if (!withdrawInfo.amount || withdrawInfo.amount <= 0) {
      alert("Informe um valor válido para saque");
      return;
    }

    if (!withdrawInfo.address) {
      alert("Informe o endereço de destino");
      return;
    }

    if (!withdrawInfo.network) {
      alert("Selecione a rede");
      return;
    }

    // Saída de cripto: segundo fator obrigatório, e é o servidor que exige.
    requestTwoFactor(async (twoFactorCode) => {
      setWithdrawLoading(true);
      let result;
      try {
        result = await RampsService.withdrawCustody(email, {
          coin: "USDT",
          amount: parseFloat(withdrawInfo.amount),
          address: withdrawInfo.address,
          network: withdrawInfo.network,
          twoFactorCode,
        });
      } finally {
        setWithdrawLoading(false);
      }

      /*
        ── Só `sent` é sucesso ──

        A rota responde 200 em todos os desfechos de negócio, de propósito: `pending_operator`
        não é falha da chamada, e tratá-lo como erro faria a tela convidar a repetir um saque
        que pode ter saído. Mas dizer "solicitado com sucesso" para `blocked` ou
        `not_configured` seria pior — o cliente ficaria esperando um dinheiro que não saiu.
      */
      if (result?.status !== "sent") {
        alert(
          result?.reason ||
            "O saque não foi concluído. Nenhum valor saiu; fale com o suporte.",
        );
        return;
      }

      setWithdrawSuccess(true);
      alert("Saque solicitado com sucesso!");

      // Reset form
      setWithdrawInfo({
        amount: "",
        address: "",
        network: "",
        email: "",
      });

      // Atualizar saldo após saque
      setTimeout(() => {
        refreshBalance();
      }, 1000);
    });
  };

  // Atualizar saldo
  const refreshBalance = async () => {
    try {
      const email = getUserEmail();
      if (email) {
        const b = await RampsService.getBalance(email);
        setBalance(b);
      }
    } catch (err) {
      console.error("Erro ao atualizar saldo:", err);
    }
  };


  /*
    ── Um só portão de segundo fator, para TODA operação que tira saldo ──

    O modal existia e cobria uma operação só: o envio de remessa em lote. Converter BRL e
    sacar USDT passavam direto. Agora quem precisa de confirmação registra AQUI o que fazer
    depois do código, e o modal não sabe qual operação é — o que impede a próxima operação
    de nascer sem portão por esquecimento de ligá-lo.

    A ação recebe o CÓDIGO, e não um "já verificei": o servidor valida o código na mesma
    requisição que move o dinheiro. Verificar antes e mandar depois deixaria uma janela
    entre a conferência e o efeito, e faria o código ser gasto duas vezes.
  */
  const [pendingAction, setPendingAction] = useState(null);

  const requestTwoFactor = (action) => {
    setPendingAction(() => action);
    setTwoFactorCode("");
    setShow2FAModal(true);
  };

  const verify2FAForTransfer = async () => {
    if (twoFactorCode.length !== 6) {
      alert("Código deve ter 6 dígitos");
      return;
    }

    setLoading2FA(true);

    try {
      /*
        Não existe mais caminho alternativo. Havia um: a remessa em lote confirmava o
        segundo fator numa chamada à PARTE e só depois enviava — a validação e o efeito em
        requisições diferentes, com uma janela entre as duas. Aquela tela saiu, e com ela o
        único consumidor daquele jeito mais fraco.

        Agora o código vai COM a operação e o servidor o valida na mesma requisição que move
        o dinheiro. Sem ação pendente não há o que confirmar: fechar é o certo, porque
        prosseguir significaria executar algo que ninguém pediu.
      */
      if (!pendingAction) {
        setShow2FAModal(false);
        setTwoFactorCode("");
        return;
      }

      await pendingAction(twoFactorCode);

      setShow2FAModal(false);
      setTwoFactorCode("");
      setPendingAction(null);
    } catch (error) {
      // A frase vem do SERVIDOR quando ele a manda: "segundo fator inválido" e "configure o
      // segundo fator" pedem coisas diferentes, e um texto fixo mandaria o cliente tentar
      // de novo um código que nunca vai funcionar porque ele não tem 2FA configurado.
      const message =
        error?.response?.data?.message ||
        "Não foi possível confirmar a operação. Confira o código e tente de novo.";
      alert(message);
    } finally {
      setLoading2FA(false);
    }
  };

  const cancel2FA = () => {
    setShow2FAModal(false);
    setTwoFactorCode("");
    setLoading2FA(false);
    setPendingAction(null);
  };

  const handleTwoFactorCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").substring(0, 6);
    setTwoFactorCode(value);
  };

  const handleEnter2FA = (e) => {
    if (e.key === "Enter" && twoFactorCode.length === 6) {
      verify2FAForTransfer();
    }
  };


  /*
    Saldo na forma da CUSTÓDIA: `balances: [{ asset, symbol, value, frozenValue }]`,
    onde `asset` é o recurso da custódia (não um símbolo) e `value` vem como
    STRING — são casas decimais que um double não representa.

    Casa por `symbol`, não por `asset`: o recurso é um identificador longo, e
    comparar contra "USDT" ali nunca casaria. Ativo que a mesa não soube nomear
    volta com `symbol` nulo e é ignorado aqui em vez de virar zero silencioso.
  */
  const extractUsdtFree = (b) => {
    const list = Array.isArray(b?.balances) ? b.balances : [];
    const usdt = list.find((x) => String(x?.symbol || "").toUpperCase() === "USDT");
    return Number(usdt?.value || 0);
  };

  /*
    A rede não é mais adivinhada aqui. Havia um `getDisplayNetwork` que tentava quatro
    campos diferentes e caía em "—": ele existia porque a tela recebia UM endereço sem
    saber a rede dele. Agora cada rede vem nomeada pela custódia, junto do seu endereço,
    e não há o que deduzir — o que importava era nunca INVENTAR (o padrão antigo era
    "BEP-20 (BSC)", herdado da subconta na corretora, numa carteira que não é BSC).
  */

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const email = getUserEmail();
        if (!email) {
          setWalletLoading(false);
          setRampLoading(false);
          return;
        }
        /*
          Cada pedaço tolera a falha do outro: sem carteira criada ainda, a consulta da
          carteira responde um estado vazio legítimo, e uma falha em qualquer um não pode
          deixar a tela sem os demais. `allSettled` em vez de `all` por isso.
        */
        const [balanceResult, walletResult, profileResult, rampResult] =
          await Promise.allSettled([
            RampsService.getBalance(email),
            RampsService.getWallet(email),
            RampsService.getRampProfile(email),
            RampsService.getRampAccounts(email),
          ]);
        if (!mounted) return;

        if (balanceResult.status === "fulfilled") setBalance(balanceResult.value);
        else console.error("Erro ao obter saldo de custódia:", balanceResult.reason);

        if (profileResult.status === "fulfilled") setRampProfile(profileResult.value);
        else console.error("Erro ao obter o cadastro na rampa:", profileResult.reason);

        // Falha deixa NULO, nunca um valor fabricado. Preencher com uma rede inventada foi
        // o que fez a tela prometer BSC para uma carteira que não é BSC.
        setWallet(walletResult.status === "fulfilled" ? walletResult.value : null);
        if (walletResult.status === "rejected")
          console.error("Erro ao obter a carteira de custódia:", walletResult.reason);
        setWalletLoading(false);

        setRamp(rampResult.status === "fulfilled" ? rampResult.value : null);
        if (rampResult.status === "rejected")
          console.error("Erro ao obter as contas de saque em fiat:", rampResult.reason);
        setRampLoading(false);


      } catch (err) {
        console.error("Erro ao obter dados iniciais:", err);
        if (mounted) {
          setWalletLoading(false);
          setRampLoading(false);
        }
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const email = getUserEmail();
    if (!email) return;
    let disposed = false;
    const load = async () => {
      try {
        const b = await RampsService.getBalance(email);
        if (!disposed) setBalance(b);
      } catch (e) {
        console.error("Erro ao atualizar saldo (polling):", e);
      }
    };
    load();
    const t = setInterval(load, 15000);
    return () => {
      disposed = true;
      clearInterval(t);
    };
  }, []);



  return (
    <section id="userPage" className="userPage transactionPage">
      <SideMenu />

      <div className="contentData">
        <div className="contentScroll">
          <div className="ramps">
            <style>{`
              .ramps {
                --bg: #ffffff;
                --card: #ffffff;
                --muted: #667085;
                --text: #101828;
                --accent: #1c787e;
                --accent-weak: rgba(57,255,20,0.14);
                --border: #e5e7eb;
                --shadow: 0 6px 18px rgba(16,24,40,.08);
                color: var(--text);
              }
              .ramps__header { margin: 8px 0 18px; }
              .ramps__title { margin: 0 0 4px; font-size: 24px; font-weight: 700; }
              .ramps__subtitle { margin: 0; color: var(--muted); }
              .ramps__grid {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 16px;
                margin-bottom: 16px;
              }
              @media (max-width: 900px) {
                .ramps__grid { grid-template-columns: 1fr; }
              }
              .card {
                background: var(--card);
                border: 1px solid var(--border);
                border-radius: 16px;
                padding: 18px;
                box-shadow: var(--shadow);
              }
              .card__title {
                font-size: 14px;
                color: var(--muted);
                margin-bottom: 10px;
                text-transform: uppercase;
                letter-spacing: .3px;
              }
              .metric { display: flex; align-items: baseline; gap: 8px; }
              .metric__value { font-size: 28px; font-weight: 800; }
              .metric__suffix { color: var(--muted); }

              .address__row {
                display: grid;
                grid-template-columns: 120px 1fr;
                gap: 8px;
                margin-bottom: 6px;
              }
              .address__label { color: var(--muted); }
              .address__value--mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }

              .form { display: grid; gap: 16px; }
              .form__label { color: var(--muted); font-size: 13px; }

              .divider {
                display: flex; align-items: center; gap: 10px;
                color: var(--muted);
              }
              .divider::before, .divider::after {
                content: ""; height: 1px; background: var(--border); flex: 1;
              }

              .table { display: grid; gap: 12px; }
              .table__head, .table__row {
                display: grid;
                grid-template-columns: 1.5fr 0.6fr 1.3fr 1fr 0.9fr 1.3fr 112px;
                gap: 12px;
                align-items: start;
              }
              .table__head {
                color: var(--muted);
                font-size: 12px;
                text-transform: uppercase;
              }
              @media (max-width: 1024px) {
                .table__head, .table__row { grid-template-columns: 1fr; }
              }

              .field { display: flex; flex-direction: column; gap: 6px; min-width: 0; }

              .input {
                background: #fff;
                border: 1px solid var(--border);
                border-radius: 10px;
                padding: 10px 12px;
                color: var(--text);
                width: 100%;
                min-width: 0;
              }
              .input::placeholder { opacity: .7; color: #9aa4b2; }
              .input:focus {
                border-color: var(--accent);
                box-shadow: 0 0 0 3px var(--accent-weak);
                outline: none;
              }
              .hint { font-size: 12px; line-height: 1.2; color: var(--muted); }

              .btn {
                background: #fff;
                border: 1px solid var(--border);
                color: var(--text);
                border-radius: 10px;
                padding: 10px 14px;
                cursor: pointer;
              }
              .btn--primary {
                background: var(--accent);
                color: #0a0a0a;
                font-weight: 700;
                border-color: transparent;
              }
              .btn--ghost {
                background: transparent;
                border: 1px solid var(--border);
                color: var(--muted);
              }
              .form__actions { display: flex; align-items: center; gap: 12px; }
              .spacer { flex: 1; }

              .quoteInline {
                display: flex; align-items: center; gap: 10px;
                font-size: 13px; color: var(--muted);
                margin-top: 4px; margin-bottom: 10px;
              }
              .quoteLabel { font-weight: 600; }
              .quoteValue { color: #16a34a; font-weight: 700; }
              .quoteValue.muted { color: var(--muted); font-weight: 500; }
              .quoteValue.error { color: #ef4444; font-weight: 600; }
              .quoteRefresh {
                background: transparent;
                border: none;
                color: var(--muted);
                cursor: pointer;
                font-size: 12px;
              }
              .quoteRefresh:hover { text-decoration: underline; }

              /* Novos estilos para os cards de swap */
              .swap-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 16px;
                margin-bottom: 24px;
              }
              @media (max-width: 1200px) {
                .swap-grid { grid-template-columns: repeat(2, 1fr); }
              }
              @media (max-width: 768px) {
                .swap-grid { grid-template-columns: 1fr; }
              }
              
              .swap-card {
                background: var(--card);
                border: 1px solid var(--border);
                border-radius: 16px;
                padding: 20px;
                box-shadow: var(--shadow);
                display: flex;
                flex-direction: column;
                gap: 16px;
              }
              
              .swap-field {
                display: flex;
                flex-direction: column;
                gap: 8px;
              }
              
              .swap-actions {
                display: flex;
                flex-direction: column;
                gap: 12px;
                margin-top: auto;
              }
              
              .swap-info {
                background: #f8fafc;
                border-radius: 8px;
                padding: 12px;
                margin-top: 8px;
                font-size: 13px;
              }
              
              .swap-info p {
                margin: 4px 0;
                color: var(--muted);
              }
              
              .swap-success {
                color: #10b981;
                font-weight: 600;
                font-size: 14px;
                text-align: center;
                padding: 8px;
                background: rgba(16, 185, 129, 0.1);
                border-radius: 6px;
              }
              
              .swap-error {
                color: #ef4444;
                font-weight: 600;
                font-size: 14px;
                text-align: center;
                padding: 8px;
                background: rgba(239, 68, 68, 0.1);
                border-radius: 6px;
              }
              
              .amount-display {
                background: #f8fafc;
                border: 1px solid var(--border);
                border-radius: 8px;
                padding: 12px;
                font-size: 16px;
                font-weight: 600;
                color: var(--text);
                text-align: center;
              }
              
              .network-select {
                width: 100%;
                padding: 10px 12px;
                border: 1px solid var(--border);
                border-radius: 10px;
                background: #fff;
                color: var(--text);
                font-size: 14px;
              }
            `}</style>

            {/*
              O cadastro na rampa OCUPA o lugar da operação enquanto não estiver
              aprovado. Saldo e botões ao lado de "em análise" convidam o cliente a
              tentar algo que o servidor vai recusar — e a recusa chega depois de ele
              preencher tudo.
            */}
            {!isRampApproved(rampProfile) ? (
              showOnboarding ? (
                <RampOnboardingForm
                  email={getUserEmail()}
                  onCancel={() => setShowOnboarding(false)}
                  /*
                    Depois de enviar, recarrega a situação em vez de assumir "em análise":
                    quem decide o estado é o provedor, e adivinhá-lo aqui mostraria "em
                    análise" para um cadastro que ele pode ter recusado na hora.
                  */
                  onSubmitted={async () => {
                    setShowOnboarding(false);
                    try {
                      setRampProfile(await RampsService.getRampProfile(getUserEmail()));
                    } catch (e) {
                      console.error("Erro ao recarregar o cadastro:", e);
                    }
                  }}
                />
              ) : (
                <RampOnboardingGate
                  profile={rampProfile}
                  onStartOnboarding={() => setShowOnboarding(true)}
                />
              )
            ) : (
              <>
            <p className="breadcrumb">
              <b>
                <span style={{ color: "#1c787e" }}>Início</span> | Ramps
              </b>
            </p>
            <br />
            <p className="title">
              <span style={{ fontWeight: "normal" }}>Crypto |</span> Ramps
            </p>
            <br />
            <div className="ramps__grid">
              <section className="card">
                <div className="card__title">Saldo disponível</div>
                <div className="metric">
                  <span className="metric__value">
                    {Number(extractUsdtFree(balance)).toFixed(6)}
                  </span>
                  <span className="metric__suffix">USDT</span>
                </div>

                {/*
                  A cotação USDT → BRL saiu junto da conversão. Ela vinha do serviço da
                  remessa e, com a conversão só no swap, mostrar um preço de BRL aqui diria
                  ao cliente que ele pode operar esse par nesta tela — e ele não pode.
                */}
              </section>

              <CustodyWalletCard wallet={wallet} loading={walletLoading} />

              <FiatAccountsCard
                currencies={ramp?.currencies || []}
                accounts={ramp?.accounts || []}
                loading={rampLoading}
                onCreate={async (currency, account) => {
                  await RampsService.createRampAccount(getUserEmail(), currency, account);
                  // Relê depois de cadastrar: a conta nasce em ANÁLISE, e é esse estado que
                  // o cliente precisa ver — não uma lista que ainda diz "nenhuma conta".
                  setRamp(await RampsService.getRampAccounts(getUserEmail()));
                }}
              />
            </div>
            {/*
              ── Três cards saíram desta tela ──

              Envio de remessa em lote, conversão BRL → USDT e registro de depósito em BRL.

              A conversão entre BRL e USDT passou a ser só no swap, pela mesa: mantê-la aqui
              deixava duas telas cotando o MESMO par por caminhos diferentes, com taxas
              diferentes, e nada dizendo ao cliente qual delas ele estava usando. Sem a
              conversão, o depósito em BRL não tinha mais o que financiar. O envio de remessa
              em lote é operação de mesa, não de autoatendimento.

              O que fica é o SAQUE de cripto, e ele passou a sair da carteira de custódia do
              cliente — não da subconta na corretora, que era a rota antiga e depreciada.
            */}
            {/* NOVOS CARDS DE SWAP */}
            <div className="swap-grid">


              {/* O único card que sobrou: o saque, agora saindo da custódia. */}
              <section className="swap-card">
                <h3 className="card__title">Saque USDT</h3>

                <div className="swap-field">
                  <label className="form__label">Valor em USDT</label>
                  <input
                    type="number"
                    className="input"
                    placeholder="Ex: 100.00"
                    value={withdrawInfo.amount}
                    onChange={(e) => {
                      setWithdrawInfo({
                        ...withdrawInfo,
                        amount: e.target.value,
                      });
                      setWithdrawSuccess(false);
                    }}
                    min="0"
                    step="0.000001"
                  />
                </div>

                <div className="swap-field">
                  <label className="form__label">Endereço de Destino</label>
                  <input
                    type="text"
                    className="input"
                    placeholder="0x..."
                    value={withdrawInfo.address}
                    onChange={(e) =>
                      setWithdrawInfo({
                        ...withdrawInfo,
                        address: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="swap-field">
                  <label className="form__label">Rede</label>
                  {/*
                    ── As opções vêm da CARTEIRA, não de uma lista escrita aqui ──

                    A lista fixa oferecia BEP-20, ERC-20, TRC-20 e Polygon — rótulos de
                    corretora, não os recursos de rede da custódia, e incluindo uma cadeia
                    (BSC) em que a carteira do cliente nem tem endereço. Escolher uma rede que
                    não existe do lado da custódia é o começo de um saque na cadeia errada, e
                    cripto na cadeia errada não volta.

                    Agora só aparecem as redes da própria carteira dele. O servidor ainda
                    RECUSA se a rede não for a do ativo — esta lista evita o erro, não o
                    substitui.
                  */}
                  <select
                    className="network-select"
                    value={withdrawInfo.network}
                    onChange={(e) =>
                      setWithdrawInfo({
                        ...withdrawInfo,
                        network: e.target.value,
                      })
                    }
                  >
                    <option value="">Selecione a rede</option>
                    {(wallet?.networks || []).map((n) => (
                      <option key={n.network} value={n.network}>
                        {n.label || n.network}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="swap-info">
                  <p>
                    <strong>Saldo disponível:</strong>{" "}
                    {Number(extractUsdtFree(balance)).toFixed(6)} USDT
                  </p>
                  <p>
                    O saque sai da sua <strong>carteira de custódia</strong>, na rede que
                    você escolher acima. Confira o endereço: transferência on-chain não
                    volta.
                  </p>
                  <p>
                    <strong>Taxas de rede:</strong> Serão deduzidas do valor
                    final
                  </p>
                  <p>
                    <strong>Tempo estimado:</strong> 5-30 minutos
                  </p>
                </div>

                {withdrawSuccess && (
                  <div className="swap-success">
                    ✓ Saque solicitado com sucesso!
                  </div>
                )}

                <div className="swap-actions">
                  <button
                    className="btn btn--primary"
                    onClick={handleWithdrawUsdt}
                    disabled={
                      withdrawLoading ||
                      !withdrawInfo.amount ||
                      withdrawInfo.amount <= 0 ||
                      !withdrawInfo.address ||
                      !withdrawInfo.network
                    }
                  >
                    {withdrawLoading ? "Solicitando..." : "Solicitar Saque"}
                  </button>
                </div>
              </section>
            </div>
              </>
            )}
          </div>

          <Footer />
        </div>
      </div>


      {show2FAModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "24px",
              minWidth: "350px",
              maxWidth: "90%",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                marginBottom: "8px",
                color: "#333",
              }}
            >
              Autenticação de Dois Fatores
            </h3>
            <p
              style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}
            >
              Digite o código de 6 dígitos do seu aplicativo autenticador:
            </p>

            <input
              type="text"
              value={twoFactorCode}
              onChange={handleTwoFactorCodeChange}
              onKeyDown={handleEnter2FA}
              maxLength="6"
              placeholder="000000"
              disabled={loading2FA}
              style={{
                width: "100%",
                padding: "12px",
                fontSize: "18px",
                textAlign: "center",
                letterSpacing: "4px",
                border: "2px solid #ddd",
                borderRadius: "6px",
                margin: "16px 0",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <button
                onClick={cancel2FA}
                disabled={loading2FA}
                style={{
                  backgroundColor: "white",
                  border: "1px solid #aaa",
                  color: "#555",
                  borderRadius: "6px",
                  padding: "10px 20px",
                  cursor: loading2FA ? "not-allowed" : "pointer",
                  opacity: loading2FA ? 0.6 : 1,
                }}
              >
                Cancelar
              </button>
              <button
                onClick={verify2FAForTransfer}
                disabled={loading2FA || twoFactorCode.length !== 6}
                style={{
                  backgroundColor:
                    loading2FA || twoFactorCode.length !== 6
                      ? "#ccc"
                      : "#1c787e",
                  border: "none",
                  color: "white",
                  borderRadius: "6px",
                  padding: "10px 20px",
                  cursor:
                    loading2FA || twoFactorCode.length !== 6
                      ? "not-allowed"
                      : "pointer",
                  fontWeight: "bold",
                }}
              >
                {loading2FA ? "Verificando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
